// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.online_preview_container[data-v-3248ee38] {\n    width: 100%;\n    height: calc(100vh - 55px);\n}\n[data-v-3248ee38] .el-dialog__body {\n  padding: 0!important;\n}\n", ""]);
// Exports
module.exports = exports;
